﻿//==========================================================================================================
// Copyright (C) Nore Technology AB. All Rights Reserved.
//==========================================================================================================

//-------------------------------------------------------------------------------------
// Imports
//-------------------------------------------------------------------------------------

//-------------------------------------------------------------------------------------
// Http Contract
//-------------------------------------------------------------------------------------

export const uri = "api/Guide/v1/Subjects";
export const method = "POST";
